import { apiInstanceFetch } from "../../../util/api";
import axios from "axios";
import * as ActionType from "./logistics.type";
import { setToast } from "../../../util/toast";

// Get confirmed orders for logistics
export const getLogisticsOrders = (start, limit, search = "") => (dispatch) => {
  dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: true });

  let url = `logistics/confirmedOrders?start=${start}&limit=${limit}`;
  if (search) {
    url += `&search=${search}`;
  }

  apiInstanceFetch
    .get(url)
    .then((res) => {
      dispatch({
        type: ActionType.GET_LOGISTICS_ORDERS,
        payload: {
          orders: res.data,
          total: res.total,
        },
      });
      dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: false });
    })
    .catch((error) => {
      console.error("Error fetching logistics orders:", error);
      dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: false });
    });
};

// Get sent to logistics orders
export const getSentLogisticsOrders = (start, limit, search = "") => (dispatch) => {
  dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: true });

  let url = `logistics/sentOrders?start=${start}&limit=${limit}`;
  if (search) {
    url += `&search=${search}`;
  }

  apiInstanceFetch
    .get(url)
    .then((res) => {
      dispatch({
        type: ActionType.GET_SENT_LOGISTICS_ORDERS,
        payload: {
          orders: res.data,
          total: res.total,
        },
      });
      dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: false });
    })
    .catch((error) => {
      console.error("Error fetching sent logistics orders:", error);
      dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: false });
    });
};

// Send order to logistics
export const sendToLogistics = (orderId, itemIndex = null) => (dispatch) => {
  dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: true });

  const data = { orderId };
  if (itemIndex !== null) {
    data.itemIndex = itemIndex;
  }

  axios
    .post("logistics/sendToLogistics", data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.SEND_TO_LOGISTICS,
          payload: {
            orderId,
            response: res.data.data,
          },
        });
        setToast("success", "Order sent to logistics successfully!");

        // Remove the order from the list since it's no longer "Confirmed"
        dispatch({
          type: ActionType.UPDATE_LOGISTICS_ORDER,
          payload: orderId,
        });
      } else {
        setToast("error", res.data.error || "Failed to send order to logistics");
      }
      dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: false });
    })
    .catch((error) => {
      console.error("Error sending to logistics:", error);
      setToast("error", error.response?.data?.error || "Failed to send order to logistics");
      dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: false });
    });
};

// Get live tracking status
export const getLiveTracking = (trackingId) => (dispatch) => {
  dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: true });

  apiInstanceFetch
    .get(`logistics/liveTracking/${trackingId}`)
    .then((res) => {
      dispatch({
        type: ActionType.SET_TRACKING_DATA,
        payload: res.data,
      });
      dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: false });
    })
    .catch((error) => {
      console.error("Error fetching tracking data:", error);
      setToast("error", "Failed to fetch tracking data");
      dispatch({ type: ActionType.SET_LOGISTICS_LOADING, payload: false });
    });
};

// Clear tracking data
export const clearTrackingData = () => (dispatch) => {
  dispatch({ type: ActionType.CLEAR_TRACKING_DATA });
};

// Delete logistics order
export const deleteLogisticsOrder = (orderId, tab) => (dispatch) => {
  axios
    .delete(`logistics/deleteOrder?orderId=${orderId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_LOGISTICS_ORDER,
          payload: { orderId, tab },
        });
        setToast("success", "Order deleted successfully!");
      } else {
        setToast("error", res.data.error || "Failed to delete order");
      }
    })
    .catch((error) => {
      console.error("Error deleting logistics order:", error);
      setToast("error", error.response?.data?.error || "Failed to delete order");
    });
};
